<div class="bet-slip slide" id="bet_slip_modal">
  <button (click)="dismiss()" class="close closepoUp">
    <span class="icon icon-close"></span>
  </button>
  <div class="modal-dialog">

    <div class="content">
      <div class="bets-list">

        <div class="modal-dark modal-body ">
          <h4 class="t-h4 mb-4">Bet Confirmation</h4>
          <p class="t-paragraph mb-4">Are you sure that you want to proceed with this bet slip?</p>
          <div class="row g-4">
            <div class="col-6">Amount</div>
            <div class="col-6 text-right t-strong">$ 60.00</div>
            <div class="col-6">Total Odds</div>
            <div class="col-6 text-right t-strong">20.0</div>
            <div class="col-6">Possible Payout</div>
            <div class="col-6 text-right t-strong">$ 1,200.00</div>
          </div>
          <button class="btn btn-block btn-fill-primary mt-4" data-toggle="modal"
            data-target="#bet-confirm-modal">{{ 'COMMON.PROCEED' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>